/**
 * Frontend-shared types. Keeps page/component contracts consistent.
 */

export const INDUSTRIES = [
  "pharmaceutical",
  "agriculture",
  "biotechnology",
  "healthcare",
  "other",
] as const;
export type Industry = (typeof INDUSTRIES)[number];

export interface PublicUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  company?: string;
  industry: Industry;
  agreedToTerms: true;
  createdAt: string;
  updatedAt: string;
}

export interface ApiSuccess<T = unknown> {
  success: true;
  data?: T;
  message?: string;
  token?: string;
  user?: PublicUser;
  email?: string;
}

export interface ApiError {
  success: false;
  message: string;
  errors?: Array<{ field?: string; message: string }>;
}

export type Theme = "light" | "dark";
export type AnimationState = "on" | "off";
